import { CheckCircle2, CircleX, Clock } from 'lucide-react';

import { EmptyState } from '@components/patterns';
import { Button } from '@components/primitives';

export type CheckoutStatusVariant =
  | 'success'
  | 'processing'
  | 'incomplete'
  | 'error';

type CheckoutStatusProps = {
  variant?: CheckoutStatusVariant;
  onRetry?: () => void;
};

export function CheckoutStatus({
  variant = 'success',
  onRetry,
}: CheckoutStatusProps) {
  if (variant === 'processing') {
    return (
      <EmptyState>
        <EmptyState.Icon>
          <Clock />
        </EmptyState.Icon>
        <EmptyState.Title>Payment received</EmptyState.Title>
        <EmptyState.Text>
          Your upgrade is still being confirmed. This usually takes a few
          seconds. Refresh the page shortly, or contact support if it does not
          appear.
        </EmptyState.Text>
      </EmptyState>
    );
  }

  if (variant === 'incomplete') {
    return (
      <EmptyState variant="failure">
        <EmptyState.Icon>
          <Clock />
        </EmptyState.Icon>
        <EmptyState.Title>Payment not completed</EmptyState.Title>
        <EmptyState.Text>
          We could not confirm your payment. Check your billing page before
          trying again.
        </EmptyState.Text>
        {onRetry && <Button onClick={onRetry}>Try again</Button>}
      </EmptyState>
    );
  }

  if (variant === 'error') {
    return (
      <EmptyState variant="failure">
        <EmptyState.Icon>
          <CircleX />
        </EmptyState.Icon>
        <EmptyState.Title>Checkout unavailable</EmptyState.Title>
        <EmptyState.Text>
          We could not start checkout. Nothing has been charged.
        </EmptyState.Text>
        {onRetry && <Button onClick={onRetry}>Try again</Button>}
      </EmptyState>
    );
  }

  return (
    <EmptyState>
      <EmptyState.Icon>
        <CheckCircle2 />
      </EmptyState.Icon>
      <EmptyState.Title>Upgraded</EmptyState.Title>
      <EmptyState.Text>Your subscription is active.</EmptyState.Text>
    </EmptyState>
  );
}
